import { useEffect, useMemo, useState } from "react";
import { Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import Checkbox from "../../../Form/Checkbox";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  META_ADAPT_PLACEMENTS_CHECKBOX_COST,
  META_ADAPT_PLACEMENTS_CHECKBOX_LABEL,
} from "../../../../i18n/keysTranslations";
import { PLAN_TYPE_CREDITS } from "../../../../utils/constants";
import { resolveActionCostForPlanType } from "../../../../utils/creditActionCosts";
import { estimateAdaptFormatsMultiplier } from "../../../../utils/metaAdaptPlacementsEligibility";
import { useCreditActionCosts } from "../../../../hooks/useCreditActionCosts";

const MetaAdaptPlacementsCheckbox = ({
  control,
  uniqueUrls = [],
  showCreditsCost = false,
}) => {
  const { t } = useTranslationApp();
  const { ADS_CAMPAIGN_GENERATE_CREATIVES_ACTION } = useCreditActionCosts();
  const [resizeSpend, setResizeSpend] = useState(null);
  const urlsKey = useMemo(() => JSON.stringify(uniqueUrls), [uniqueUrls]);

  useEffect(() => {
    const urls = JSON.parse(urlsKey);

    if (!showCreditsCost || !Array.isArray(urls) || urls.length === 0) {
      setResizeSpend(null);
      return undefined;
    }

    let cancelled = false;
    setResizeSpend(null);

    const unitCost =
      resolveActionCostForPlanType(
        ADS_CAMPAIGN_GENERATE_CREATIVES_ACTION,
        PLAN_TYPE_CREDITS
      ).amount || 0;

    estimateAdaptFormatsMultiplier(urls).then((multiplier) => {
      if (cancelled) return;
      const spend = unitCost * multiplier;
      setResizeSpend(spend > 0 ? spend : null);
    });

    return () => {
      cancelled = true;
    };
  }, [ADS_CAMPAIGN_GENERATE_CREATIVES_ACTION, showCreditsCost, urlsKey]);

  const costSuffix =
    showCreditsCost && resizeSpend
      ? ` ${t(META_ADAPT_PLACEMENTS_CHECKBOX_COST, { count: resizeSpend })}`
      : "";

  return (
    <Controller
      name="adaptCreativesToPlacements"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          sx={{
            alignItems: "flex-start",
            mx: 0,
            maxWidth: 600,
            width: "100%",
          }}
          control={
            <Checkbox
              checked={Boolean(field.value)}
              onChange={(e) => field.onChange(e.target.checked)}
              sx={{ mt: 0.25 }}
            />
          }
          label={
            <Typography variant="body2" sx={{ pt: 0.6 }}>
              {`${t(META_ADAPT_PLACEMENTS_CHECKBOX_LABEL)}${costSuffix}`}
            </Typography>
          }
        />
      )}
    />
  );
};

export default MetaAdaptPlacementsCheckbox;
